import { createContext, useContext, useState, useCallback } from "react";
import { DEFAULT_CODES } from "./site";

const STORAGE_KEY = "novaera_codes";
const CodesContext = createContext(null);

const loadCodes = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (saved && saved.downloader && saved.ntdown) return saved;
  } catch (e) {}
  return DEFAULT_CODES;
};

export const CodesProvider = ({ children }) => {
  const [codes, setCodes] = useState(loadCodes);
  const [adminOpen, setAdminOpen] = useState(false);

  const saveCodes = useCallback((next) => {
    setCodes(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  }, []);

  const resetCodes = useCallback(() => {
    setCodes(DEFAULT_CODES);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return (
    <CodesContext.Provider
      value={{ codes, saveCodes, resetCodes, adminOpen, setAdminOpen }}
    >
      {children}
    </CodesContext.Provider>
  );
};

export const useCodes = () => useContext(CodesContext);
